// App.js
import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import { useChat } from '@ai-sdk/react';
import { DefaultChatTransport } from 'ai';
import { Analytics } from '@vercel/analytics/react';
import CreditPurchaseModal from './CreditPurchaseModal';
import ReactMarkdown from 'react-markdown';

import { initializeApp } from 'firebase/app';
import {
  getAuth,
  GoogleAuthProvider,
  onAuthStateChanged,
  signInWithPopup,
  signInWithRedirect,
  getRedirectResult,
  signOut
} from 'firebase/auth';

import {
  getFirestore,
  doc,
  getDoc,
  setDoc,
  onSnapshot,
  runTransaction
} from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyDYN40xFtUfQUWV3MSg3N6BubppdThmAUw",
  authDomain: "bluey-ecb71.firebaseapp.com",
  projectId: "bluey-ecb71",
  storageBucket: "bluey-ecb71.firebasestorage.app",
  messagingSenderId: "722046019918",
  appId: "1:722046019918:web:7b6037414e437caaded61f",
  measurementId: "G-DR6ZQW9HDH"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();
// Add custom parameters to ensure popup works properly
provider.setCustomParameters({
  prompt: 'select_account'
});
const db = getFirestore(app);

// ========================================
// ICON COMPONENTS
// ========================================

const Icons = {
  Sun: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="5"/><line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/><line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
    </svg>
  ),
  Moon: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
    </svg>
  ),
  Copy: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>
    </svg>
  ),
  Check: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="20 6 9 17 4 12"/>
    </svg>
  ),
  Send: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/>
    </svg>
  ),
  Upload: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/>
    </svg>
  ),
  Coins: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="8" cy="8" r="6"/><path d="M18.09 10.37A6 6 0 1 1 10.34 18"/><path d="M7 6h1v4"/><path d="m16.71 13.88.7.71-2.82 2.82"/>
    </svg>
  ),
  Star: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" strokeWidth="2">
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
    </svg>
  ),
  Users: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
    </svg>
  ),
  Shield: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
    </svg>
  ),
  X: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
    </svg>
  ),
  Sparkles: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z"/><path d="M5 3v4"/><path d="M19 17v4"/><path d="M3 5h4"/><path d="M17 19h4"/>
    </svg>
  ),
  ChevronDown: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="6 9 12 15 18 9"/>
    </svg>
  ),
};

// ========================================
// TYPING INDICATOR COMPONENT
// ========================================

const TypingIndicator = () => (
  <div className="message assistant" role="status" aria-live="polite" aria-label="Assistant is typing">
    <div className="message-avatar">
      <Icons.Sparkles />
    </div>
    <div className="message-bubble typing">
      <span className="typing-dot"></span>
      <span className="typing-dot"></span>
      <span className="typing-dot"></span>
    </div>
  </div>
);

// ========================================
// MESSAGE COMPONENT
// ========================================

const RetryIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/>
  </svg>
);

const Message = ({ message, isUser, onRetry }) => {
  const [copied, setCopied] = useState(false);
  const [copiedCodeBlock, setCopiedCodeBlock] = useState(null);

  // Get text content from message parts or content
  const getTextContent = () => {
    if (message.parts) {
      return message.parts
        .filter(part => part.type === 'text')
        .map(part => part.text)
        .join('');
    }
    return message.content || '';
  };

  const textContent = getTextContent();

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(textContent);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  const handleCopyCode = async (code, index) => {
    try {
      await navigator.clipboard.writeText(code);
      setCopiedCodeBlock(index);
      setTimeout(() => setCopiedCodeBlock(null), 2000);
    } catch (err) {
      console.error('Failed to copy code:', err);
    }
  };

  // Track code block index for copy buttons
  let codeBlockIndex = 0;

  return (
    <div className={`message ${isUser ? 'user' : 'assistant'}`}>
      <div className="message-avatar">
        {isUser ? '👤' : <Icons.Sparkles />}
      </div>
      <div className={`message-bubble ${!isUser ? 'markdown-content' : ''}`}>
        {!isUser && textContent && (
          <button 
            className={`copy-button ${copied ? 'copied' : ''}`}
            onClick={handleCopy}
            title={copied ? 'Copied!' : 'Copy to clipboard'}
          >
            {copied ? <Icons.Check /> : <Icons.Copy />}
          </button>
        )}
        <ReactMarkdown
          components={{
            // Headings
            h1: ({ children }) => <h1 className="md-h1">{children}</h1>,
            h2: ({ children }) => <h2 className="md-h2">{children}</h2>,
            h3: ({ children }) => <h3 className="md-h3">{children}</h3>,
            h4: ({ children }) => <h4 className="md-h4">{children}</h4>,
            h5: ({ children }) => <h5 className="md-h5">{children}</h5>,
            h6: ({ children }) => <h6 className="md-h6">{children}</h6>,

            // Paragraphs
            p: ({ children }) => <p className="md-p">{children}</p>,

            // Lists
            ul: ({ children }) => <ul className="md-ul">{children}</ul>,
            ol: ({ children }) => <ol className="md-ol">{children}</ol>,
            li: ({ children }) => <li className="md-li">{children}</li>,

            // Blockquote
            blockquote: ({ children }) => <blockquote className="md-blockquote">{children}</blockquote>,

            // Code blocks and inline code
            code: ({ inline, className, children, ...props }) => {
              const codeString = String(children).replace(/\n$/, '');
              const match = /language-(\w+)/.exec(className || '');
              const language = match ? match[1] : '';

              if (!inline) {
                const currentIndex = codeBlockIndex++;
                return (
                  <div className="md-code-block-wrapper">
                    <div className="md-code-header">
                      <span className="md-code-lang">{language || 'code'}</span>
                      <button
                        className={`md-code-copy ${copiedCodeBlock === currentIndex ? 'copied' : ''}`}
                        onClick={() => handleCopyCode(codeString, currentIndex)}
                        title={copiedCodeBlock === currentIndex ? 'Copied!' : 'Copy code'}
                      >
                        {copiedCodeBlock === currentIndex ? <Icons.Check /> : <Icons.Copy />}
                      </button>
                    </div>
                    <pre className="md-pre">
                      <code className={`md-code ${className || ''}`} {...props}>
                        {children}
                      </code>
                    </pre>
                  </div>
                );
              }
              return <code className="md-inline-code" {...props}>{children}</code>;
            },

            // Links
            a: ({ href, children }) => (
              <a href={href} className="md-link" target="_blank" rel="noopener noreferrer">
                {children}
              </a>
            ),

            // Strong and emphasis
            strong: ({ children }) => <strong className="md-strong">{children}</strong>,
            em: ({ children }) => <em className="md-em">{children}</em>,

            // Horizontal rule
            hr: () => <hr className="md-hr" />,

            // Tables
            table: ({ children }) => (
              <div className="md-table-wrapper">
                <table className="md-table">{children}</table>
              </div>
            ),
            thead: ({ children }) => <thead className="md-thead">{children}</thead>,
            tbody: ({ children }) => <tbody className="md-tbody">{children}</tbody>,
            tr: ({ children }) => <tr className="md-tr">{children}</tr>,
            th: ({ children }) => <th className="md-th">{children}</th>,
            td: ({ children }) => <td className="md-td">{children}</td>,
          }}
        >
          {textContent}
        </ReactMarkdown>
        {!isUser && message._failed && onRetry && (
          <button className="btn-retry" onClick={() => onRetry(message)}>
            <RetryIcon /> Retry
          </button>
        )}
      </div>
    </div>
  );
};

// ========================================
// TYPEWRITER EFFECT COMPONENT
// ========================================

const phrases = [
  "a plurality opinion?",
  "an unpublished disposition?",
  "a superseded regulation?",
  "overruled dicta?",
  "parallel state reporters?",
  "legislative history?",
  "a treaty protocol?",
  "interim final rules?",
];

const TypewriterEffect = () => {
  const [currentPhrase, setCurrentPhrase] = useState(0);
  const [currentText, setCurrentText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    const phrase = phrases[currentPhrase];
    const timeout = setTimeout(() => {
      if (!isDeleting) {
        if (currentText.length < phrase.length) {
          setCurrentText(phrase.slice(0, currentText.length + 1));
        } else {
          setTimeout(() => setIsDeleting(true), 2000);
        }
      } else {
        if (currentText.length > 0) {
          setCurrentText(currentText.slice(0, -1));
        } else {
          setIsDeleting(false);
          setCurrentPhrase((prev) => (prev + 1) % phrases.length);
        }
      }
    }, isDeleting ? 30 : 80);

    return () => clearTimeout(timeout);
  }, [currentText, isDeleting, currentPhrase]);

  return (
    <div className="typewriter-container">
      <span className="typewriter-prefix">How do I cite</span>
      <span className="typewriter-text">{currentText}</span>
      <span className="typewriter-cursor">|</span>
    </div>
  );
};

// ========================================
// SAMPLE PROMPTS COMPONENT
// ========================================

const samplePrompts = [
  {
    label: "Plurality + Concurrence",
    prompt: "I need to cite Justice Kennedy's concurrence in Parents Involved in Community Schools v. Seattle School District No. 1, 551 U.S. 701 (2007), which was a plurality opinion. How do I format this when the concurrence is more influential than the plurality, and what's the proper parenthetical to indicate it's controlling in the Ninth Circuit?"
  },
  {
    label: "Superseded Statute",
    prompt: "How do I cite the original Section 404 of the Securities Act of 1933 before it was amended by the Dodd-Frank Act, when I need to show the historical version that was in effect in 1998, including the proper Statutes at Large reference and U.S.C.A. annotation showing it was later superseded?"
  },
  {
    label: "Foreign + Treaty",
    prompt: "I'm citing a German Federal Constitutional Court (Bundesverfassungsgericht) decision from 2020 that interprets Article 8 of the European Convention on Human Rights. How do I format the German case citation with the BVerfGE reporter, then add a parenthetical referencing the ECHR treaty provision with the proper E.T.S. number?"
  },
  {
    label: "Admin Rulemaking",
    prompt: "Cite the EPA's 2015 Clean Power Plan final rule (80 Fed. Reg. 64,662) that was stayed by the Supreme Court, then vacated and replaced by the 2019 ACE rule, which was itself partially vacated by the D.C. Circuit. I need to show the full procedural history with all three regulatory actions and their current status."
  },
  {
    label: "Unpub. + Rehearing",
    prompt: "I have an unpublished Ninth Circuit memorandum disposition from 2022 that was initially decided 2-1, then granted rehearing en banc, but the en banc petition was later withdrawn and the original panel opinion reinstated with a modified footnote. How do I cite the final version with the procedural history?"
  },
  {
    label: "Multi-Vol. Leg. History",
    prompt: "I need to cite a specific floor statement by Senator Biden from the Congressional Record during the 1994 Crime Bill debate, which appears in both the daily edition and the bound permanent edition with different pagination. The statement was also reprinted in the U.S.C.C.A.N. legislative history compilation. Which source takes priority and how do I format parallel citations?"
  },
];

const SamplePrompts = ({ onSelect }) => (
  <div className="sample-prompts">
    <div className="sample-prompts-label">Try a complex citation →</div>
    <div className="sample-prompts-grid">
      {samplePrompts.map((item, idx) => (
        <button
          key={idx}
          className="sample-prompt-chip"
          onClick={() => onSelect(item.prompt)}
        >
          {item.label}
        </button>
      ))}
    </div>
  </div>
);

// ========================================
// MODEL SELECTOR
// ========================================

// Keep in sync with api/openrouter.js `allowedModels`.
const availableModels = [
  { id: 'google/gemini-3.5-flash', name: 'Gemini 3.5 Flash', desc: 'Fast & efficient' },
  { id: 'anthropic/claude-opus-4.8', name: 'Claude Opus 4.8', desc: 'Top reasoning' },
  { id: 'anthropic/claude-sonnet-4.6', name: 'Claude Sonnet 4.6', desc: 'Balanced & sharp' },
  { id: 'google/gemini-3-pro-preview', name: 'Gemini 3 Pro', desc: 'Advanced reasoning' },
  { id: 'openai/gpt-5.5', name: 'GPT-5.5', desc: 'Latest GPT' },
  { id: 'x-ai/grok-4.3', name: 'Grok 4.3', desc: 'Fast & capable' },
];

const DEFAULT_MODEL = 'google/gemini-3.5-flash';

const ModelSelector = ({ selectedModel, onSelect }) => {
  const [isOpen, setIsOpen] = useState(false);
  const selected = availableModels.find(m => m.id === selectedModel) || availableModels[0];

  return (
    <div className="model-selector">
      <button
        className="model-selector-trigger"
        onClick={() => setIsOpen(!isOpen)}
        aria-haspopup="listbox"
        aria-expanded={isOpen}
        aria-label={`Model: ${selected.name}`}
      >
        <span className="model-name">{selected.name}</span>
        <Icons.ChevronDown />
      </button>
      {isOpen && (
        <>
          <div className="model-selector-backdrop" onClick={() => setIsOpen(false)} />
          <div className="model-selector-dropdown" role="listbox" aria-label="Select AI model">
            {availableModels.map((model) => (
              <button
                key={model.id}
                role="option"
                aria-selected={model.id === selectedModel}
                className={`model-option ${model.id === selectedModel ? 'active' : ''}`}
                onClick={() => {
                  onSelect(model.id);
                  setIsOpen(false);
                }}
              >
                <span className="model-option-name">{model.name}</span>
                <span className="model-option-desc">{model.desc}</span>
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

// ========================================
// LOW CREDIT TOAST COMPONENT
// ========================================

const LowCreditToast = ({ onBuyCredits, onDismiss }) => (
  <div className="toast-container" role="alert" aria-live="polite">
    <div className="toast warning">
      <span className="toast-message">Low credits!</span>
      <button className="btn-base btn-primary" onClick={onBuyCredits} style={{ padding: '0.4rem 0.75rem', fontSize: '0.75rem' }}>
        Buy More
      </button>
      <button className="btn-base btn-ghost" onClick={onDismiss} aria-label="Dismiss">
        <Icons.X />
      </button>
    </div>
  </div>
);

// ========================================
// DRAG & DROP UPLOAD ZONE
// ========================================

const UploadZone = ({ onFileSelect, isDragOver, setIsDragOver }) => {
  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragOver(true);
  };

  const handleDragLeave = () => {
    setIsDragOver(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragOver(false);
    const file = e.dataTransfer.files[0];
    if (file && file.name.endsWith('.docx')) {
      onFileSelect(file);
    }
  };

  const handleClick = () => {
    document.getElementById('file-input').click();
  };

  return (
    <div 
      className={`upload-zone ${isDragOver ? 'drag-over' : ''}`}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      onClick={handleClick}
    >
      <Icons.Upload />
      <span>Upload .docx for citation check</span>
    </div>
  );
};

// ========================================
// MAIN APP COMPONENT
// ========================================

function App() {
  const [user, setUser] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);
  const [credits, setCredits] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [theme, setTheme] = useState('light');
  const [isDragOver, setIsDragOver] = useState(false);
  const [showLowCreditToast, setShowLowCreditToast] = useState(false);
  const [selectedModel, setSelectedModel] = useState(DEFAULT_MODEL);
  const [pendingMessage, setPendingMessage] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadStep, setUploadStep] = useState(0); // 0=idle, 1=uploading, 2=parsing, 3=analyzing
  const [chatError, setChatError] = useState(null);

  const chatContainerRef = useRef(null);
  const fileInputRef = useRef(null);
  const homeTextareaRef = useRef(null);
  const chatTextareaRef = useRef(null);

  // Latest user/credits in a ref so stable callbacks (useChat onError) avoid stale closures
  const userRef = useRef(null);
  const lastSentTextRef = useRef('');

  // Local input state (more reliable than useChat's input)
  const [inputValue, setInputValue] = useState('');

  // Refund a single credit (used when a message fails after the credit was deducted)
  const refundCredit = useCallback(async () => {
    const currentUser = userRef.current;
    if (!currentUser) return;
    try {
      const userDocRef = doc(db, 'users', currentUser.uid);
      await runTransaction(db, async (transaction) => {
        const snap = await transaction.get(userDocRef);
        const data = snap.data();
        if (!data) return;
        transaction.update(userDocRef, { credits: (data.credits || 0) + 1 });
      });
    } catch (err) {
      console.error('Failed to refund credit:', err);
    }
  }, []);

  // Memoize transport so it only re-creates when selectedModel changes
  const transport = useMemo(
    () => new DefaultChatTransport({
      api: '/api/openrouter',
      body: { model: selectedModel },
    }),
    [selectedModel]
  );

  // Use Vercel AI SDK useChat hook with transport for v5+
  const { messages, sendMessage, status, setMessages } = useChat({
    transport,
    onError: (err) => {
      console.error('Chat error:', err);
      setChatError('Something went wrong generating a response. Your credit was refunded — please try again.');
      refundCredit();
    },
  });

  const isStreaming = status === 'streaming' || status === 'submitted';
  const isLoading = isStreaming || isUploading;
  const chatStarted = messages.length > 0;

  // Theme persistence
  useEffect(() => {
    const savedTheme = localStorage.getItem('theme') || 'light';
    setTheme(savedTheme);
    document.documentElement.setAttribute('data-theme', savedTheme);
  }, []);

  // Keep a ref to the current user for stable callbacks
  useEffect(() => {
    userRef.current = user;
  }, [user]);

  const toggleTheme = () => {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    setTheme(newTheme);
    localStorage.setItem('theme', newTheme);
    document.documentElement.setAttribute('data-theme', newTheme);
  };

  // Low credit warning
  useEffect(() => {
    if (credits !== null && credits > 0 && credits <= 5 && user) {
      setShowLowCreditToast(true);
    }
  }, [credits, user]);

  // Handle redirect result (for fallback authentication)
  useEffect(() => {
    getRedirectResult(auth)
      .then((result) => {
        if (result) {
          // User signed in via redirect
          console.log('Sign in via redirect successful');
        }
      })
      .catch((error) => {
        // Handle redirect errors silently - they're usually user cancellation
        if (error.code !== 'auth/popup-closed-by-user' && error.code !== 'auth/cancelled-popup-request') {
          console.error('Redirect sign-in error:', error);
        }
      });
  }, []);

  // Auth and credits setup
  useEffect(() => {
    let unsubscribeSnapshot = null;
    const handleAuthStateChanged = (currentUser) => {
      setUser(currentUser);
      setAuthLoading(false);
      if (currentUser) {
        const userDocRef = doc(db, 'users', currentUser.uid);
        getDoc(userDocRef).then((userDocSnap) => {
          if (!userDocSnap.exists()) {
            return setDoc(userDocRef, { credits: 100 });
          }
          return null;
        }).then(() => {
          unsubscribeSnapshot = onSnapshot(userDocRef, (snapshot) => {
            if (snapshot.exists()) {
              setCredits(snapshot.data().credits);
            }
          });
        }).catch(error => {
          console.error("Error initializing user credits:", error);
        });
      } else {
        setCredits(null);
        if (unsubscribeSnapshot) {
          unsubscribeSnapshot();
          unsubscribeSnapshot = null;
        }
      }
    };
    const unsubscribeAuth = onAuthStateChanged(auth, handleAuthStateChanged);
    return () => {
      unsubscribeAuth();
      if (unsubscribeSnapshot) unsubscribeSnapshot();
    };
  }, []);

  // Handle pending message after sign-in
  useEffect(() => {
    const sendPending = async () => {
      if (pendingMessage && user && credits !== null && credits > 0) {
        const messageText = pendingMessage;
        setPendingMessage(null);

        try {
          const userDocRef = doc(db, 'users', user.uid);
          await runTransaction(db, async (transaction) => {
            const userDocSnap = await transaction.get(userDocRef);
            const userData = userDocSnap.data();
            if (!userData || userData.credits <= 0) {
              throw new Error('no-credits');
            }
            transaction.update(userDocRef, { credits: userData.credits - 1 });
          });
          sendMessage({ text: messageText });
          setInputValue('');
        } catch (error) {
          if (error.message === 'no-credits') {
            setShowModal(true);
            return;
          }
          console.error('Error sending message:', error);
        }
      }
    };
    sendPending();
  }, [pendingMessage, user, credits, sendMessage]);

  // Auto-scroll
  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTo({
        top: chatContainerRef.current.scrollHeight,
        behavior: 'smooth',
      });
    }
  }, [messages, isLoading]);

  // Reset textarea height when input is cleared
  useEffect(() => {
    if (!inputValue) {
      [homeTextareaRef.current, chatTextareaRef.current].forEach(el => {
        if (!el) return;
        el.style.height = '';
        el.classList.remove('expanded');
        const row = el.closest('.input-row, .chat-input-form');
        if (row) row.classList.remove('expanded');
      });
    }
  }, [inputValue]);

  const handleSignIn = async () => {
    try {
      await signInWithPopup(auth, provider);
    } catch (error) {
      console.error('Sign-in error:', error);
      
      // Handle specific error codes
      if (error.code === 'auth/unauthorized-domain') {
        const currentDomain = window.location.hostname;
        alert(
          `Domain not authorized for OAuth.\n\n` +
          `Your current domain (${currentDomain}) needs to be added to Firebase's authorized domains.\n\n` +
          `To fix this:\n` +
          `1. Go to Firebase Console (https://console.firebase.google.com)\n` +
          `2. Select your project (bluey-ecb71)\n` +
          `3. Go to Authentication → Settings → Authorized domains\n` +
          `4. Click "Add domain" and add: ${currentDomain}\n` +
          `5. Try signing in again`
        );
      } else if (error.code === 'auth/popup-blocked') {
        alert('Popup blocked. Please allow popups for this site and try again, or use the redirect method.');
        // Fallback to redirect
        try {
          await signInWithRedirect(auth, provider);
        } catch (redirectError) {
          console.error('Redirect sign-in error:', redirectError);
          alert('Unable to sign in. Please check your browser settings and try again.');
        }
      } else if (error.code === 'auth/popup-closed-by-user') {
        // User closed the popup - this is fine, don't show an error
        console.log('User closed popup');
      } else if (error.code === 'auth/cancelled-popup-request') {
        // Another popup is already open - this is fine
        console.log('Popup request cancelled - another popup may be open');
      } else if (error.code === 'auth/network-request-failed') {
        alert('Network error. Please check your internet connection and try again.');
      } else {
        // For other errors, show the error message
        alert(`Sign-in failed: ${error.message || error.code || 'Unknown error'}\n\nError code: ${error.code || 'N/A'}`);
      }
    }
  };

  const handleSendMessage = async (messageText) => {
    if (!user) {
      setPendingMessage(messageText);
      handleSignIn();
      return;
    }
    if (!messageText || !messageText.trim()) return;
    if (credits === null) {
      alert('Loading your credits. Please wait a moment and try again.');
      return;
    }
    if (credits <= 0) {
      setShowModal(true);
      return;
    }

    try {
      // Atomically deduct credit using a transaction to prevent race conditions
      const userDocRef = doc(db, 'users', user.uid);
      await runTransaction(db, async (transaction) => {
        const userDocSnap = await transaction.get(userDocRef);
        const userData = userDocSnap.data();
        if (!userData || userData.credits <= 0) {
          throw new Error('no-credits');
        }
        transaction.update(userDocRef, { credits: userData.credits - 1 });
      });

      // Send message using AI SDK
      setChatError(null);
      lastSentTextRef.current = messageText;
      sendMessage({ text: messageText });
      setInputValue('');
    } catch (error) {
      if (error.message === 'no-credits') {
        setShowModal(true);
        return;
      }
      console.error('Error sending message:', error);
      setChatError('Could not send your message. Please check your connection and try again.');
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleSendMessage(inputValue);
  };

  const handleClear = () => {
    setMessages([]);
    setInputValue('');
    setChatError(null);
  };

  const handleErrorRetry = () => {
    const text = lastSentTextRef.current;
    setChatError(null);
    if (text) handleSendMessage(text);
  };

  const handleRetry = (failedMessage) => {
    // Remove the failed message from the list
    setMessages(prev => prev.filter(m => m.id !== failedMessage.id));

    // If this was a failed brief upload, re-upload the file
    if (failedMessage._failedFile) {
      handleFileSelect(failedMessage._failedFile);
    } else {
      // For failed chat messages, find the last user message and resend
      const lastUserMsg = [...messages].reverse().find(m => m.role === 'user');
      if (lastUserMsg) {
        const text = lastUserMsg.content || lastUserMsg.parts?.filter(p => p.type === 'text').map(p => p.text).join('') || '';
        if (text) handleSendMessage(text);
      }
    }
  };

  const handleSignOut = () => {
    signOut(auth).catch(err => console.error(err));
  };

  const handleOpenBuyModal = () => {
    if (!user) {
      alert('Please sign in first!');
      return;
    }
    setShowModal(true);
    setShowLowCreditToast(false);
  };

  const handleSelectPlan = async (plan) => {
    try {
      const response = await fetch('/api/create-checkout-session', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ userId: user.uid, credits: plan }),
      });
      const data = await response.json();
      if (data.url) {
        window.location.href = data.url;
      } else {
        alert('Failed to create checkout session.');
      }
    } catch (err) {
      console.error(err);
      alert('Error creating checkout session.');
    }
  };

  const handleFileSelect = async (file) => {
    if (!user) {
      handleSignIn();
      return;
    }
    if (credits === null || credits <= 0) {
      setShowModal(true);
      return;
    }

    if (!file.name.toLowerCase().endsWith('.docx')) {
      alert("Only .docx files are supported.");
      return;
    }

    const maxSize = 10 * 1024 * 1024;
    if (file.size > maxSize) {
      alert("File is too large. Maximum size is 10MB.");
      return;
    }

    setIsUploading(true);
    setUploadStep(1);
    try {
      // Atomically deduct credit before processing
      const userDocRef = doc(db, 'users', user.uid);
      await runTransaction(db, async (transaction) => {
        const userDocSnap = await transaction.get(userDocRef);
        const userData = userDocSnap.data();
        if (!userData || userData.credits <= 0) {
          throw new Error('no-credits');
        }
        transaction.update(userDocRef, { credits: userData.credits - 1 });
      });

      // Add user message manually (not using chat API)
      const userMsgId = `user-${Date.now()}`;
      setMessages(prev => [...prev, { id: userMsgId, role: 'user', content: `Uploaded brief for citation check: ${file.name}` }]);

      setUploadStep(2);
      const formData = new FormData();
      formData.append("docxFile", file);

      const response = await fetch('/api/brief', {
        method: 'POST',
        body: formData,
      });

      setUploadStep(3);

      if (!response.ok) {
        throw new Error("Failed to process brief");
      }

      const data = await response.json();

      // Add assistant response manually
      setMessages(prev => [...prev, { id: `assistant-${Date.now()}`, role: 'assistant', content: data.response }]);
    } catch (error) {
      if (error.message === 'no-credits') {
        setShowModal(true);
        return;
      }
      console.error("Error processing brief:", error);
      setMessages(prev => [...prev, { id: `error-${Date.now()}`, role: 'assistant', content: "Sorry, something went wrong processing your brief. Please try again.", _failed: true, _failedFile: file }]);
    } finally {
      setIsUploading(false);
      setUploadStep(0);
    }
  };

  const handleBriefUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      handleFileSelect(file);
    }
    e.target.value = null;
  };

  if (authLoading) {
    return (
      <div className="app-container loading">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  return (
    <>
      <div className="app-container">
        {/* Header */}
        <header className="header-bar">
          <div className="header-left">
            <span className="logo">Bluey</span>
            <div className="credits-display">
              <Icons.Coins />
              <span>{user && credits !== null ? credits : '—'}</span>
            </div>
          </div>
          
          <div className="header-actions">
            <button className="theme-toggle" onClick={toggleTheme} aria-label="Toggle theme">
              {theme === 'light' ? <Icons.Moon /> : <Icons.Sun />}
            </button>
            
            {user ? (
              <>
                <button className="btn-base btn-primary" onClick={handleOpenBuyModal}>
                  Buy Credits
                </button>
                <button className="btn-base btn-outline" onClick={handleSignOut}>
                  Sign Out
                </button>
              </>
            ) : (
              <button className="btn-base btn-primary" onClick={handleSignIn}>
                Sign In
              </button>
            )}
          </div>
        </header>

        {/* Main Content */}
        <main className="main-content">
          {!chatStarted ? (
            // Home View
            <div className="home-view">
              <section className="hero-section">
                <h1 className="hero-title">
                  Legal Citation <span className="accent">Generator</span>
                </h1>
                <p className="hero-subtitle">
                  AI-powered Bluebook citation assistant
                </p>
                <TypewriterEffect />
                
                <div className="trust-indicators">
                  <div className="trust-item">
                    <Icons.Star />
                    <span>4.9/5 rating</span>
                  </div>
                  <div className="trust-item">
                    <Icons.Users />
                    <span>500+ lawyers</span>
                  </div>
                  <div className="trust-item">
                    <Icons.Shield />
                    <span>Bluebook 21st Ed.</span>
                  </div>
                </div>
              </section>

              {/* Input Section */}
              <div className="input-section">
                <form onSubmit={handleSubmit} className="input-form">
                  <div className="input-row">
                    <ModelSelector selectedModel={selectedModel} onSelect={setSelectedModel} />
                    <textarea
                      ref={homeTextareaRef}
                      className={`input-field ${inputValue.includes('\n') || inputValue.length > 60 ? 'expanded' : ''}`}
                      placeholder="Ask a citation question..."
                      value={inputValue}
                      onChange={(e) => {
                        setInputValue(e.target.value);
                        const target = e.target;
                        const row = target.closest('.input-row');
                        target.style.height = '36px';
                        const newHeight = Math.min(target.scrollHeight, 180);
                        target.style.height = newHeight + 'px';
                        const isExpanded = newHeight > 44;
                        target.classList.toggle('expanded', isExpanded);
                        if (row) row.classList.toggle('expanded', isExpanded);
                      }}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' && !e.shiftKey) {
                          e.preventDefault();
                          if (inputValue.trim()) handleSubmit(e);
                        }
                      }}
                      rows={1}
                    />
                    <button type="submit" className="btn-base btn-primary btn-send" disabled={!inputValue.trim()}>
                      <Icons.Send />
                    </button>
                  </div>
                </form>
                
                {/* Sample Prompts */}
                <SamplePrompts onSelect={(prompt) => {
                  setInputValue(prompt);
                  // Auto-expand textarea after state update
                  setTimeout(() => {
                    const textarea = homeTextareaRef.current;
                    const row = textarea?.closest('.input-row');
                    if (textarea) {
                      textarea.style.height = '36px';
                      const newHeight = Math.min(textarea.scrollHeight, 180);
                      textarea.style.height = newHeight + 'px';
                      const isExpanded = newHeight > 44;
                      textarea.classList.toggle('expanded', isExpanded);
                      if (row) row.classList.toggle('expanded', isExpanded);
                      textarea.focus();
                    }
                  }, 0);
                }} />
              </div>

              {/* Upload Zone */}
              {isUploading ? (
                <div className="upload-progress" role="status" aria-live="polite">
                  <div className="upload-steps">
                    {[
                      { step: 1, label: 'Uploading' },
                      { step: 2, label: 'Parsing document' },
                      { step: 3, label: 'Checking citations' },
                    ].map(({ step, label }) => (
                      <div key={step} className={`upload-step ${uploadStep >= step ? 'active' : ''} ${uploadStep > step ? 'done' : ''}`}>
                        <div className="upload-step-indicator">
                          {uploadStep > step ? '\u2713' : step}
                        </div>
                        <span className="upload-step-label">{label}{uploadStep === step ? '...' : ''}</span>
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                <UploadZone
                  onFileSelect={handleFileSelect}
                  isDragOver={isDragOver}
                  setIsDragOver={setIsDragOver}
                />
              )}
            </div>
          ) : (
            // Chat View
            <div className="chat-view">
              <div className="chat-container" ref={chatContainerRef} role="log" aria-live="polite">
                {messages.map((msg) => (
                  <Message
                    key={msg.id}
                    message={msg}
                    isUser={msg.role === 'user'}
                    onRetry={handleRetry}
                  />
                ))}
                {isLoading && <TypingIndicator />}
                {chatError && (
                  <div className="chat-error" role="alert">
                    <span className="chat-error-text">{chatError}</span>
                    <button className="btn-retry" onClick={handleErrorRetry}>
                      <RetryIcon /> Retry
                    </button>
                  </div>
                )}
              </div>

              {/* Chat Input */}
              <div className="chat-input-section">
                <form onSubmit={handleSubmit} className="chat-input-form">
                  <ModelSelector selectedModel={selectedModel} onSelect={setSelectedModel} />
                  <textarea
                    ref={chatTextareaRef}
                    className={`chat-input ${inputValue.includes('\n') || inputValue.length > 50 ? 'expanded' : ''}`}
                    placeholder="Ask a follow-up question..."
                    value={inputValue}
                    onChange={(e) => {
                      setInputValue(e.target.value);
                      const target = e.target;
                      const form = target.closest('.chat-input-form');
                      target.style.height = '40px';
                      const newHeight = Math.min(target.scrollHeight, 180);
                      target.style.height = newHeight + 'px';
                      const isExpanded = newHeight > 48;
                      target.classList.toggle('expanded', isExpanded);
                      if (form) form.classList.toggle('expanded', isExpanded);
                    }}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' && !e.shiftKey) {
                        e.preventDefault();
                        if (inputValue.trim() && !isLoading) handleSubmit(e);
                      }
                    }}
                    disabled={isLoading}
                    rows={1}
                  />
                  <button 
                    type="submit" 
                    className="btn-base btn-primary btn-send"
                    disabled={isLoading || !inputValue.trim()}
                  >
                    <Icons.Send />
                  </button>
                  <button type="button" className="btn-base btn-outline" onClick={handleClear}>
                    New
                  </button>
                </form>
              </div>
            </div>
          )}
        </main>

        <Analytics />
      </div>

      {/* Hidden file input */}
      <input
        id="file-input"
        type="file"
        accept=".docx"
        style={{ display: 'none' }}
        ref={fileInputRef}
        onChange={handleBriefUpload}
      />

      {/* Low Credit Toast */}
      {showLowCreditToast && (
        <LowCreditToast 
          onBuyCredits={handleOpenBuyModal}
          onDismiss={() => setShowLowCreditToast(false)}
        />
      )}

      {/* Credit Purchase Modal */}
      <CreditPurchaseModal
        show={showModal}
        onClose={() => setShowModal(false)}
        onSelectPlan={handleSelectPlan}
      />
    </>
  );
}

export default App;
